export default {
  1: {
    0.5: 0.0,
    0.6: 0.325,
    0.75: 1.0,
    0.8: 1.376,
    0.85: 1.963,
    0.9: 3.078,
    0.95: 6.314,
    0.975: 12.71,
    0.99: 31.82,
    0.995: 63.66,
    0.9975: 127.3,
    0.999: 318.3,
    0.9995: 636.6
  },
  2: {
    0.5: 0.0,
    0.6: 0.289,
    0.75: 0.816,
    0.8: 1.061,
    0.85: 1.386,
    0.9: 1.886,
    0.95: 2.92,
    0.975: 4.303,
    0.99: 6.965,
    0.995: 9.925,
    0.9975: 14.09,
    0.999: 22.33,
    0.9995: 31.6
  },
  3: {
    0.5: 0.0,
    0.6: 0.277,
    0.75: 0.765,
    0.8: 0.978,
    0.85: 1.25,
    0.9: 1.638,
    0.95: 2.353,
    0.975: 3.182,
    0.99: 4.541,
    0.995: 5.841,
    0.9975: 7.453,
    0.999: 10.21,
    0.9995: 12.92
  },
  4: {
    0.5: 0.0,
    0.6: 0.271,
    0.75: 0.741,
    0.8: 0.941,
    0.85: 1.19,
    0.9: 1.533,
    0.95: 2.132,
    0.975: 2.776,
    0.99: 3.747,
    0.995: 4.604,
    0.9975: 5.598,
    0.999: 7.173,
    0.9995: 8.61
  },
  5: {
    0.5: 0.0,
    0.6: 0.267,
    0.75: 0.727,
    0.8: 0.92,
    0.85: 1.156,
    0.9: 1.476,
    0.95: 2.015,
    0.975: 2.571,
    0.99: 3.365,
    0.995: 4.032,
    0.9975: 4.773,
    0.999: 5.893,
    0.9995: 6.869
  },
  6: {
    0.5: 0.0,
    0.6: 0.265,
    0.75: 0.718,
    0.8: 0.906,
    0.85: 1.134,
    0.9: 1.44,
    0.95: 1.943,
    0.975: 2.447,
    0.99: 3.143,
    0.995: 3.707,
    0.9975: 4.317,
    0.999: 5.208,
    0.9995: 5.959
  },
  7: {
    0.5: 0.0,
    0.6: 0.263,
    0.75: 0.711,
    0.8: 0.896,
    0.85: 1.119,
    0.9: 1.415,
    0.95: 1.895,
    0.975: 2.365,
    0.99: 2.998,
    0.995: 3.499,
    0.9975: 4.029,
    0.999: 4.785,
    0.9995: 5.408
  },
  8: {
    0.5: 0.0,
    0.6: 0.262,
    0.75: 0.706,
    0.8: 0.889,
    0.85: 1.108,
    0.9: 1.397,
    0.95: 1.86,
    0.975: 2.306,
    0.99: 2.896,
    0.995: 3.355,
    0.9975: 3.833,
    0.999: 4.501,
    0.9995: 5.041
  },
  9: {
    0.5: 0.0,
    0.6: 0.261,
    0.75: 0.703,
    0.8: 0.883,
    0.85: 1.1,
    0.9: 1.383,
    0.95: 1.833,
    0.975: 2.262,
    0.99: 2.821,
    0.995: 3.25,
    0.9975: 3.69,
    0.999: 4.297,
    0.9995: 4.781
  },
  10: {
    0.5: 0.0,
    0.6: 0.26,
    0.75: 0.7,
    0.8: 0.879,
    0.85: 1.093,
    0.9: 1.372,
    0.95: 1.812,
    0.975: 2.228,
    0.99: 2.764,
    0.995: 3.169,
    0.9975: 3.581,
    0.999: 4.144,
    0.9995: 4.587
  },
  11: {
    0.5: 0.0,
    0.6: 0.26,
    0.75: 0.697,
    0.8: 0.876,
    0.85: 1.088,
    0.9: 1.363,
    0.95: 1.796,
    0.975: 2.201,
    0.99: 2.718,
    0.995: 3.106,
    0.9975: 3.497,
    0.999: 4.025,
    0.9995: 4.437
  },
  12: {
    0.5: 0.0,
    0.6: 0.259,
    0.75: 0.695,
    0.8: 0.873,
    0.85: 1.083,
    0.9: 1.356,
    0.95: 1.782,
    0.975: 2.179,
    0.99: 2.681,
    0.995: 3.055,
    0.9975: 3.428,
    0.999: 3.93,
    0.9995: 4.318
  },
  13: {
    0.5: 0.0,
    0.6: 0.259,
    0.75: 0.694,
    0.8: 0.87,
    0.85: 1.079,
    0.9: 1.35,
    0.95: 1.771,
    0.975: 2.16,
    0.99: 2.65,
    0.995: 3.012,
    0.9975: 3.372,
    0.999: 3.852,
    0.9995: 4.221
  },
  14: {
    0.5: 0.0,
    0.6: 0.258,
    0.75: 0.692,
    0.8: 0.868,
    0.85: 1.076,
    0.9: 1.345,
    0.95: 1.761,
    0.975: 2.145,
    0.99: 2.624,
    0.995: 2.977,
    0.9975: 3.326,
    0.999: 3.787,
    0.9995: 4.14
  },
  15: {
    0.5: 0.0,
    0.6: 0.258,
    0.75: 0.691,
    0.8: 0.866,
    0.85: 1.074,
    0.9: 1.341,
    0.95: 1.753,
    0.975: 2.131,
    0.99: 2.602,
    0.995: 2.947,
    0.9975: 3.286,
    0.999: 3.733,
    0.9995: 4.073
  },
  16: {
    0.5: 0.0,
    0.6: 0.258,
    0.75: 0.69,
    0.8: 0.865,
    0.85: 1.071,
    0.9: 1.337,
    0.95: 1.746,
    0.975: 2.12,
    0.99: 2.583,
    0.995: 2.921,
    0.9975: 3.252,
    0.999: 3.686,
    0.9995: 4.015
  },
  17: {
    0.5: 0.0,
    0.6: 0.257,
    0.75: 0.689,
    0.8: 0.863,
    0.85: 1.069,
    0.9: 1.333,
    0.95: 1.74,
    0.975: 2.11,
    0.99: 2.567,
    0.995: 2.898,
    0.9975: 3.222,
    0.999: 3.646,
    0.9995: 3.965
  },
  18: {
    0.5: 0.0,
    0.6: 0.257,
    0.75: 0.688,
    0.8: 0.862,
    0.85: 1.067,
    0.9: 1.33,
    0.95: 1.734,
    0.975: 2.101,
    0.99: 2.552,
    0.995: 2.878,
    0.9975: 3.197,
    0.999: 3.61,
    0.9995: 3.922
  },
  19: {
    0.5: 0.0,
    0.6: 0.257,
    0.75: 0.688,
    0.8: 0.861,
    0.85: 1.066,
    0.9: 1.328,
    0.95: 1.729,
    0.975: 2.093,
    0.99: 2.539,
    0.995: 2.861,
    0.9975: 3.174,
    0.999: 3.579,
    0.9995: 3.883
  },
  20: {
    0.5: 0.0,
    0.6: 0.257,
    0.75: 0.687,
    0.8: 0.86,
    0.85: 1.064,
    0.9: 1.325,
    0.95: 1.725,
    0.975: 2.086,
    0.99: 2.528,
    0.995: 2.845,
    0.9975: 3.153,
    0.999: 3.552,
    0.9995: 3.85
  },
  21: {
    0.5: 0.0,
    0.6: 0.257,
    0.75: 0.686,
    0.8: 0.859,
    0.85: 1.063,
    0.9: 1.323,
    0.95: 1.721,
    0.975: 2.08,
    0.99: 2.518,
    0.995: 2.831,
    0.9975: 3.135,
    0.999: 3.527,
    0.9995: 3.819
  },
  22: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.686,
    0.8: 0.858,
    0.85: 1.061,
    0.9: 1.321,
    0.95: 1.717,
    0.975: 2.074,
    0.99: 2.508,
    0.995: 2.819,
    0.9975: 3.119,
    0.999: 3.505,
    0.9995: 3.792
  },
  23: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.685,
    0.8: 0.858,
    0.85: 1.06,
    0.9: 1.319,
    0.95: 1.714,
    0.975: 2.069,
    0.99: 2.5,
    0.995: 2.807,
    0.9975: 3.104,
    0.999: 3.485,
    0.9995: 3.767
  },
  24: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.685,
    0.8: 0.857,
    0.85: 1.059,
    0.9: 1.318,
    0.95: 1.711,
    0.975: 2.064,
    0.99: 2.492,
    0.995: 2.797,
    0.9975: 3.091,
    0.999: 3.467,
    0.9995: 3.745
  },
  25: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.684,
    0.8: 0.856,
    0.85: 1.058,
    0.9: 1.316,
    0.95: 1.708,
    0.975: 2.06,
    0.99: 2.485,
    0.995: 2.787,
    0.9975: 3.078,
    0.999: 3.45,
    0.9995: 3.725
  },
  26: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.684,
    0.8: 0.856,
    0.85: 1.058,
    0.9: 1.315,
    0.95: 1.706,
    0.975: 2.056,
    0.99: 2.479,
    0.995: 2.779,
    0.9975: 3.067,
    0.999: 3.435,
    0.9995: 3.707
  },
  27: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.684,
    0.8: 0.855,
    0.85: 1.057,
    0.9: 1.314,
    0.95: 1.703,
    0.975: 2.052,
    0.99: 2.473,
    0.995: 2.771,
    0.9975: 3.057,
    0.999: 3.421,
    0.9995: 3.69
  },
  28: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.683,
    0.8: 0.855,
    0.85: 1.056,
    0.9: 1.313,
    0.95: 1.701,
    0.975: 2.048,
    0.99: 2.467,
    0.995: 2.763,
    0.9975: 3.047,
    0.999: 3.408,
    0.9995: 3.674
  },
  29: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.683,
    0.8: 0.854,
    0.85: 1.055,
    0.9: 1.311,
    0.95: 1.699,
    0.975: 2.045,
    0.99: 2.462,
    0.995: 2.756,
    0.9975: 3.038,
    0.999: 3.396,
    0.9995: 3.659
  },
  30: {
    0.5: 0.0,
    0.6: 0.256,
    0.75: 0.683,
    0.8: 0.854,
    0.85: 1.055,
    0.9: 1.31,
    0.95: 1.697,
    0.975: 2.042,
    0.99: 2.457,
    0.995: 2.75,
    0.9975: 3.03,
    0.999: 3.385,
    0.9995: 3.646
  },
  40: {
    0.5: 0.0,
    0.6: 0.255,
    0.75: 0.681,
    0.8: 0.851,
    0.85: 1.05,
    0.9: 1.303,
    0.95: 1.684,
    0.975: 2.021,
    0.99: 2.423,
    0.995: 2.704,
    0.9975: 2.971,
    0.999: 3.307,
    0.9995: 3.551
  },
  50: {
    0.5: 0.0,
    0.6: 0.255,
    0.75: 0.679,
    0.8: 0.849,
    0.85: 1.047,
    0.9: 1.299,
    0.95: 1.676,
    0.975: 2.009,
    0.99: 2.403,
    0.995: 2.678,
    0.9975: 2.937,
    0.999: 3.261,
    0.9995: 3.496
  },
  60: {
    0.5: 0.0,
    0.6: 0.254,
    0.75: 0.679,
    0.8: 0.848,
    0.85: 1.045,
    0.9: 1.296,
    0.95: 1.671,
    0.975: 2.0,
    0.99: 2.39,
    0.995: 2.66,
    0.9975: 2.915,
    0.999: 3.232,
    0.9995: 3.46
  },
  80: {
    0.5: 0.0,
    0.6: 0.254,
    0.75: 0.678,
    0.8: 0.846,
    0.85: 1.043,
    0.9: 1.292,
    0.95: 1.664,
    0.975: 1.99,
    0.99: 2.374,
    0.995: 2.639,
    0.9975: 2.887,
    0.999: 3.195,
    0.9995: 3.416
  },
  100: {
    0.5: 0.0,
    0.6: 0.254,
    0.75: 0.677,
    0.8: 0.845,
    0.85: 1.042,
    0.9: 1.29,
    0.95: 1.66,
    0.975: 1.984,
    0.99: 2.364,
    0.995: 2.626,
    0.9975: 2.871,
    0.999: 3.174,
    0.9995: 3.39
  },
  120: {
    0.5: 0.0,
    0.6: 0.254,
    0.75: 0.677,
    0.8: 0.845,
    0.85: 1.041,
    0.9: 1.289,
    0.95: 1.658,
    0.975: 1.98,
    0.99: 2.358,
    0.995: 2.617,
    0.9975: 2.86,
    0.999: 3.16,
    0.9995: 3.373
  }
};
